export default {
  init() {
    initMap();
    function initMap(attempts, url) {
      if (attempts === undefined) {
        attempts = 0;
      }

      if (typeof google === 'undefined') {
        if (attempts < 1000) {
          window.setTimeout(function() { initMap(attempts+1, url) }, 100);
          return;
        } else {
          return;
        }
      }

      loadMap();
    }

    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 130 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document. documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document. documentElement.clientWidth)
      );
    }

    function loadMap() {
      const mapOptions = {
        zoom: 11,
        center: new google.maps.LatLng(54.672265, 25.266711),

        panControl: false,
        overviewMapControl: false,
        scaleControl: false,
        streetViewControl: false,
        scrollwheel: false,
        zoomControl: true,
        draggable: false,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.LARGE,
          position: google.maps.ControlPosition.LEFT_CENTER
        },

        mapTypeControl: false,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.RIGHT_TOP
        },
        fullscreenControl: false,
        styles:[
          {
            "featureType":"landscape",
            "stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]
          },
          {
            "featureType":"poi",
            "stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]
          },
          {
            "featureType":"road.highway",
            "stylers":[{"saturation":-100},{"visibility":"simplified"}]
          },
          {
            "featureType":"road.arterial",
            "stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]
          },
          {
            "featureType":"road.local",
            "stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]
          },
          {
            "featureType":"transit",
            "stylers":[{"saturation":-100},{"visibility":"simplified"}]
          },
          {
            "featureType":"administrative.province",
            "stylers":[{"visibility":"off"}]
          },
          {
            "featureType":"water",
            "elementType":"labels",
            "stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]
          },
          {
            "featureType":"water",
            "elementType":"geometry",
            "stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]
          }
        ]
      };

      const markerIcons = {
        'normal': {
          url: '/images/marker.svg',
          scaledSize: new google.maps.Size(18, 18),
        },
        'hover':  {
          url: '/images/marker.svg',
          scaledSize: new google.maps.Size(18, 18),
        },
        'active': {
          url: '/images/marker.svg',
          scaledSize: new google.maps.Size(18, 18),
        }
      };

      function init_map(map, map_el) {
        let offsetCenter;

        const centerWithOffset = function(latlng, offX, offY) {
          if (map.getProjection() === undefined) return;
          if (window.matchMedia('screen and (max-width:550px)').matches) {
            if (offX === undefined) offX = 0;
            if (offY === undefined) offY = jQuery(window).height() * 0.1;
          } else {
            if (offX === undefined) offX = -160;
            if (offY === undefined) offY = 40;
          }

          offsetCenter = latlng;

          const scale = Math.pow(2, map.getZoom());

          const worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
          const pixelOffset = new google.maps.Point((offX/scale) || 0,(offY/scale) ||0);

          const worldCoordinateNewCenter = new google.maps.Point(
            worldCoordinateCenter.x - pixelOffset.x,
            worldCoordinateCenter.y + pixelOffset.y
          );

          const newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

          map.setCenter(newCenter);
        };

        const showAddress = function(elem, force_top) {
          if (force_top === undefined) {
            force_top = false;
          }
          if (!isElementInViewport(elem)) {
            elem.scrollIntoView({block: force_top ? "start" : "nearest", inline: "nearest", behavior: "smooth"});
          }
          if (!isElementInViewport(map_el)) {
            map_el.scrollIntoView({block: "nearest", inline: "nearest", behavior: "smooth"});
          }
        };

        map.addListener('projection_changed', function() {
          centerWithOffset(new google.maps.LatLng(54.755952, 25.273916));
        });

        map.addListener('zoom_changed', function() {
          centerWithOffset(offsetCenter);
        });

        $('[data-coords]').on('click', function(el){
          el.preventDefault();

          const $this = $(this);
          const coords = $this.attr('data-coords').split(",");

          $this.parent().parent().find('li > a').removeClass('active');
          $(this).addClass('active');

          map.setZoom(11);
          centerWithOffset(new google.maps.LatLng(coords[0], coords[1]));

          const map_type = $this.parent().parent().parent().data('store');

          $(`#parduotuves-adresai-${map_type} .city-list`).hide();
          $(`.${$this.attr('href').substring(1)}`).show();
        });

        $.each($('[data-coords].active'), function() {
          const $this = $(this);
          const coords = $this.attr('data-coords').split(",");

          $this.parent().parent().find('li > a').removeClass('active');
          $(this).addClass('active');

          map.setZoom(11);
          centerWithOffset(new google.maps.LatLng(coords[0], coords[1]));

          const map_type = $this.parent().parent().parent().data('store');

          $(`#parduotuves-adresai-${map_type} .city-list`).hide();
          $(`.${$this.attr('href').substring(1)}`).show();
        });

        $(`#${map_el.getAttribute('id')}`).next('.addresses').find('.show-on-map').each(function(index, item){
          const $this = jQuery(this);
          const coords = $this.attr('data-coords').split(",");
          const $city = $this.closest('.city-list');
          const $city_link = jQuery('.cities a[href="#'+$city[0].id+'"]');

          const marker = new google.maps.Marker({
            position: new google.maps.LatLng(coords[0], coords[1]),
            map: map,
            optimized: false,
            icon: markerIcons.normal,
          });

          const mouseenterStore = function() {
            marker.setIcon(markerIcons.hover);
            $this.addClass('hover');
          };

          const mouseleaveStore = function() {
            marker.setIcon(markerIcons.normal);
            $this.removeClass('hover');
          };

          const selectStore = function() {
            marker.setIcon(markerIcons.active);
            map.setZoom(15);
            centerWithOffset(marker.getPosition());
            jQuery('.addresses .show-on-map').removeClass('active');
            $this.addClass('active');
            jQuery('.cities li > a').removeClass('active');
            $city_link.addClass('active');
            showAddress(item);
          };

          $this.on('click', selectStore)
            .on('mouseenter', mouseenterStore)
            .on('mouseleave', mouseleaveStore);

          google.maps.event.addListener(marker, 'click', selectStore);
          google.maps.event.addListener(marker, 'mouseover', mouseenterStore);
          google.maps.event.addListener(marker, 'mouseout', mouseleaveStore);
        });
      }

      const map_canvases = document.querySelectorAll('.map-canvas');

      map_canvases.forEach((el) => {
        init_map(new google.maps.Map(el, mapOptions), el);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/store-maps.js